import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { headerMenuService } from '@/services/headerMenuService';
import { getRefreshConfig } from '@/config/refresh.config';

export const useHeaderMenus = () => {
  return useQuery({
    queryKey: ['headerMenus'],
    queryFn: () => headerMenuService.list(),
    staleTime: 5 * 60 * 1000,
    ...getRefreshConfig('static'),
  });
};

export const useCreateHeaderMenu = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (menuData: Record<string, unknown>) => headerMenuService.create(menuData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['headerMenus'] });
    },
  });
};

export const useUpdateHeaderMenu = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: Record<string, unknown> }) =>
      headerMenuService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['headerMenus'] });
    },
  });
};

export const useDeleteHeaderMenu = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => headerMenuService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['headerMenus'] });
    },
  });
};

export const useReorderHeaderMenus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (menuIds: (string | number)[]) => headerMenuService.reorder(menuIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['headerMenus'] });
    },
  });
};
